const inicialState = {
  isLoading: false,
  hasError: false,
  cepError: false,
  streetType: '',
  street: '',
  district: '',
  city: '',
  state: '',
  zipCode: ''
}

export default (state = inicialState, action) => {
  switch (action.type) {
    case 'FETCH_ADDRESS':
      return { ...state, isLoading: true, hasError: false, cepError: false }
    case 'FETCH_ADDRESS_SUCCESS':
      const { request, data } = action.payload
      const zipCode = request.responseURL.split('/').pop()
      return { ...state, isLoading: false, ...data, zipCode }
    case 'FETCH_ADDRESS_FAIL':
      const cepError = !!action.error.response
      const hasError = !cepError
      return {
        ...inicialState,
        isLoading: false,
        hasError,
        cepError
      }
    case 'CLEAN_ERROR_ADDRESS':
      return {
        ...state,
        cepError: false,
        hasError: false
      }
    case 'RESET_CART_SHIPPING':
      return inicialState
    case 'SET_ADDRESS':
      return { ...state, isLoading: false, ...action.address }
    default:
      return { ...state }
  }
}

export const getAddress = ({ participant, address }) => {
  return {
    participant,
    hasError: address.hasError,
    cepError: address.cepError,
    isLoading: address.isLoading,
    zipCode: participant.address && participant.address.zipCode,
    number: participant.address && participant.address.number,
    complement: participant.address && participant.address.complement,
    reference: participant.address && participant.address.reference,
    receiver: participant.name,
    street: {
      value: address.street,
      valueParticipant: participant.address.addressText.value,
      disabled: participant.address && participant.address.addressText.disabled
    },
    streetType: {
      value: address.streetType,
      disabled: participant.address && participant.address.addressText.disabled
    },
    district: {
      value: address.district,
      valueParticipant: participant.address.district.value,
      disabled: participant.address && participant.address.district.disabled
    },
    city: {
      value: address.city,
      disabled: participant.address && participant.address.city.disabled
    },
    state: {
      value: address.state,
      disabled: participant.address && participant.address.state.disabled
    }
  }
}



// WEBPACK FOOTER //
// ./src/features/Address/reducer.js